import Vue from 'vue'
import Vuex from 'vuex'

// import example from './module-example'
import reports from './reports'
import shared from './shared'
import approvals from './approvals'
import auth from './auth'
import attend from './attend'
import users from './users'
import courses from './courses'
import classes from './classes'
import students from './students'
import documents from './documents'
import notifications from './notifications'
import orders from './orders'
import certificates from './certficates'
import events from './events'
import jobs from './jobs'
import addressVerification from './addressVerification'
import settings from './settings'

Vue.use(Vuex)

const store = new Vuex.Store({
  // strict: true,
  modules: {
    reports,
    approvals,
    shared,
    auth,
    attend,
    users,
    courses,
    classes,
    students,
    documents,
    certificates,
    notifications,
    orders,
    events,
    jobs,
    addressVerification,
    settings,
  }
})

export default store
